@if (iconStyleResolved === 'fontawesome') {
    <div class="header">
        {{ label }}
        <span class="pe-2">
            @if (direction === 'asc') {
                <span><fa-icon [icon]="faSortUp"></fa-icon></span>
            }
            @if (direction === 'desc') {
                <span><fa-icon [icon]="faSortDown"></fa-icon></span>
            }
            @if (direction == null) {
                <span style="color: #bdbdbd">
                    <fa-icon [icon]="faSort"></fa-icon>
                </span>
            }
        </span>
    </div>
} @else {
    <div class="header d-flex align-items-center">
        {{ label }}
        <div class="ms-2" style="color: rgb(188, 188, 189)">
            @if (direction === 'asc') {
                <span style="display: grid">
                    <svg
                        width="9"
                        height="9"
                        fill="currentColor"
                        viewBox="0 0 1048 1048"
                        style="color: var(--bs-primary)">
                        <path d="M1024 768.001h-1024l512.001-512.001z"></path>
                    </svg>
                    <svg width="9" height="9" fill="currentColor" viewBox="0 0 1048 1048">
                        <path d="M1024 256h-1024l512 512z"></path>
                    </svg>
                </span>
            }
            @if (direction === 'desc') {
                <span style="display: grid">
                    <svg width="9" height="9" fill="currentColor" viewBox="0 0 1048 1048">
                        <path d="M1024 768.001h-1024l512.001-512.001z"></path>
                    </svg>
                    <svg
                        width="9"
                        height="9"
                        fill="currentColor"
                        viewBox="0 0 1048 1048"
                        style="color: var(--bs-primary)">
                        <path d="M1024 256h-1024l512 512z"></path>
                    </svg>
                </span>
            }
            @if (direction == null) {
                <span style="display: grid">
                    <svg width="9" height="9" fill="currentColor" viewBox="0 0 1048 1048">
                        <path d="M1024 768.001h-1024l512.001-512.001z"></path>
                    </svg>
                    <svg width="9" height="9" fill="currentColor" viewBox="0 0 1048 1048">
                        <path d="M1024 256h-1024l512 512z"></path>
                    </svg>
                </span>
            }
        </div>
    </div>
}
